import { Directive, ElementRef, HostListener, Renderer2, inject, input } from '@angular/core';

@Directive({
  selector: '[appPasswordToggle]',
  standalone: true,
})
export class PasswordToggleDirective {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  readonly toggleInput = input<HTMLInputElement>();
  private _shown = false;

  @HostListener('click') onClick() {
    this.toggle();
  }

  private toggle(): void {
    console.log('TOGGLE');

    const toggleInput = this.toggleInput();
    if (toggleInput) {
      this._shown = !this._shown;
      const inputType = this._shown ? 'text' : 'password';
      this.renderer.setAttribute(toggleInput, 'type', inputType);
      this.updateIcon();
    }
  }

  private updateIcon(): void {
    const icon = this.el.nativeElement.querySelector('mat-icon');
    if (icon) {
      this.renderer.setProperty(
        icon,
        'innerText',
        this._shown ? 'visibility_off' : 'visibility'
      );
    }
  }
}
